import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';

import './_styles.scss';

interface MapShowMissionRouteButtonProps {
    onClick(): void;
    isShown?: boolean;
}

const MapShowMissionRouteButton = ({ onClick, isShown }: MapShowMissionRouteButtonProps) => {
    if (!isShown) {
        return null;
    }

    return (
        <OverlayTrigger
            placement='top'
            overlay={
                <Tooltip>
                    <p className='whitespace-pre-line'>Show mission route</p>
                </Tooltip>
            }
        >
            <div className='MapSettingsTile MapCenterMarkerButton' onClick={onClick}>
                <div className='MapSettingsButton'>
                    <div className='CustomMapSettingsButton__body'>
                        <span className='rioglyph rioglyph-route-view CustomMapSettingsButton__icon' />
                    </div>
                </div>
            </div>
        </OverlayTrigger>
    );
};

export default MapShowMissionRouteButton;
